import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModificaCampo } from '../../../_helpers/propagazione-comune';

// Feature 122 (issue #3377) — US1: dialogo di allineamento della pianifica collegata, mostrato al
// salvataggio di un ordine cliente PIANIFICATO quando almeno un campo dello snapshot è cambiato.
//
// Fino alla feature 121 quella pianifica si aggiornava DA SOLA, senza che nessuno lo chiedesse e
// senza che nessuno lo vedesse: chi correggeva un refuso in una nota d'ordine cambiava la pianifica
// di un altro reparto senza saperlo. Questo dialogo rende l'effetto visibile e governabile, come già
// fatto dalle feature 120 (Anagrafica → Ordini) e 121 (Articolo → Ordini).
//
// ⚠️ SCELTA ATOMICA, NESSUNA CASELLA DI SPUNTA (FR-003, decisione D2). A differenza del dialogo di
// propagazione dell'anagrafica, qui l'elenco è in SOLA LETTURA: `NotaJson` è uno snapshot INTEGRALE,
// e una selezione campo per campo produrrebbe in pianifica uno stato che non è mai esistito su
// nessun ordine, rompendo la parità fra export ordini ed export pianifiche (feature 114).
//
// ⚠️ Annullare o chiudere senza scegliere equivale a «non allineare» e NON annulla il salvataggio
// dell'ordine (FR-008): il dismiss senza dati è gestito dal chiamante come `false`.
//
// standalone: false, dichiarato in SharedModule accanto al componente che lo apre. Struttura, stile
// e `cssClass` sono quelli di `propaga-ordini-modal` (feature 120): stesso aspetto, stesse azioni.
@Component({
  selector: 'app-allinea-pianifica-modal',
  templateUrl: './allinea-pianifica-modal.component.html',
  standalone: false,
})
export class AllineaPianificaModalComponent implements OnInit {
  @Input() modifiche: ModificaCampo[];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    if (!this.modifiche) this.modifiche = [];
  }

  // «Aggiorna la pianifica»: l'ordine viene salvato E la pianifica allineata.
  conferma(): void {
    this.modalController.dismiss(true, 'confirm');
  }

  // «Non aggiornare»: l'ordine viene salvato lo stesso, la pianifica resta com'era.
  // ⚠️ Non è un errore e non va presentato come tale (FR-008, SC-003).
  annulla(): void {
    this.modalController.dismiss(false, 'cancel');
  }
}
